import React from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { login as redexLogin } from "../redux/authSlice";
import { toast } from "react-toastify";
import apiClient from "../api/apiClient";
import { useIndexPageData } from "../contextapi/Indexpagedata";
import { handleErrors } from "../modules/handleErrors";
import {
  clearStoredReferralId,
  getStoredReferralId,
} from "../utils/referral";
import { hasPendingCartItems } from "../utils/pendingCart";
import { trackEvent } from "../analytics";

function GoogleSocialLogin({
  onHide,
  onSuccess,
  stayOnPage = false,
  variant = "icon",
  label,
  analyticsContext = "standard",
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { fetchDataprofile } = useIndexPageData();

  const handleLoginSuccess = async (response) => {
    const accessToken = response.access_token;

    try {
      const backend = "google-oauth2";
      const referralId = getStoredReferralId();
      const res = await apiClient.post(`/social_login/social/${backend}/`, {
        access_token: accessToken,
        ...(referralId ? { referral_id: referralId } : {}),
      });

      if (!res.ok) {
        handleErrors(res.data);
        return;
      }

      const role = res.data?.role;
      const userId = res.data?.user?.id;
      dispatch(
        redexLogin({
          token: res.data?.token,
          userType: role,
          role,
          userid: userId,
        })
      );

      if (
        res.data?.created === true ||
        res.data?.is_new_user === true ||
        res.data?.isNewUser === true
      ) {
        trackEvent("sign_up", {
          method: "google",
          registration_context: analyticsContext,
        });
      }

      clearStoredReferralId();
      if (userId) await fetchDataprofile(userId);
      toast.success("You have signed in successfully.");

      if (role === "A") {
        onHide?.();
        navigate("/admin/dashboard");
        return;
      }
      if (role === "F") {
        onHide?.();
        navigate("/affiliate/dashboard");
        return;
      }

      if (stayOnPage) {
        onSuccess?.();
        return;
      }

      onHide?.();
      navigate(hasPendingCartItems() ? "/cart" : "/");
    } catch (error) {
      console.error("API call failed:", error);
      toast.error("Google sign-in failed. Please try again.");
    }
  };

  const handleLoginError = (error) => {
    console.error("Login Failed:", error);
  };

  const login = useGoogleLogin({
    onSuccess: handleLoginSuccess,
    onError: handleLoginError,
    onNonOAuthError: (error) => {
      console.error("Non-OAuth Error:", error);
      if (error.type === "popup_blocked") {
        toast.error(
          "Popup was blocked by the browser. Please allow popups and try again."
        );
      } else if (error.type === "popup_closed") {
        toast.error("Google login was cancelled. Please try again.");
      } else {
        toast.error("An error occurred during Google login.");
      }
    },
  });

  if (variant === "button") {
    return (
      <button
        type="button"
        className="btn checkout-auth__google w-100 d-inline-flex align-items-center justify-content-center gap-2"
        onClick={() => login()}
      >
        {label || "Sign in with Google"}
      </button>
    );
  }

  return (
    <div className="">
      <div className="mx-2" onClick={() => login()} role="button" tabIndex={0}>
        <img alt="Sign in with Google" src={"../assets/images/google-icon.png"} />
      </div>
    </div>
  );
}

export default GoogleSocialLogin;
